module.exports = __webpack_public_path__ + "static/media/service-contract.a6b4041d.svg";